module.exports = __webpack_public_path__ + "static/media/78.929e569b.png";